/** @format */

import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { PaymentDeadlineCodeCollectionInterface } from '../../interfaces/collections/PaymentDeadlineCodeCollectionInterface';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import { paymentDeadlineCodeConstants } from './actions';

export class PaymentDeadlineCodeLoader {
    private itemLoader: ItemLoaders;
    private paymentDeadlineCodesURL = '/payment_deadline_codes';
    private paymentDeadLineCodes: PaymentDeadlineCodeCollectionInterface | null = null;

    constructor(itemLoader: ItemLoaders) {
        this.itemLoader = itemLoader;
    }

    loadPaymentDeadlineCodes = (filters: Array<Filter>, orders: Array<Order>, callback: null | (() => void) = null): void => {
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getUrl(this.paymentDeadlineCodesURL),
            paymentDeadlineCodeConstants.LIST,
            filters,
            orders,
            (data: PaymentDeadlineCodeCollectionInterface): void => {
                this.paymentDeadLineCodes = data;
                if (callback) {
                    callback();
                }
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    getPaymentDeadLineCodes = (): PaymentDeadlineCodeCollectionInterface | null => {
        return this.paymentDeadLineCodes;
    };
}
